import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article2026Guide from "../pages/article/cssbuy-spreadsheet-2026-guide/page";
import ComparisonArticle from "../pages/article/kakobuy-vs-cssbuy-comparison/page";
import BudgetFindsArticle from "../pages/article/best-budget-finds-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/cssbuy-spreadsheet-2026-guide",
    element: <Article2026Guide />,
  },
  {
    path: "/article/kakobuy-vs-cssbuy-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "/article/best-budget-finds-2026",
    element: <BudgetFindsArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;